module.exports = __webpack_public_path__ + "img/b_UBA@2x.b2775923.png";